import _ from "lodash";
import langs from "./langs";

function toLocaleObject(value) {
  return value && typeof value === "object" ? value : {};
}

function normalizeOrganSystem(item) {
  return {
    ...item,
    description: toLocaleObject(item.description),
  };
}

export default {
  state: {
    pesticides: [],
    active_ingredients: [],
    crops: [],
    pests: [],
    organSystems: [],
  },
  mutations: {
    setPesticides(state, payload) {
      state.pesticides = payload;
    },
    setActiveIngredients(state, payload) {
      state.active_ingredients = payload;
    },
    setCrops(state, payload) {
      state.crops = payload;
    },
    setPests(state, payload) {
      state.pests = payload;
    },
    setOrganSystems(state, payload) {
      state.organSystems = Array.isArray(payload)
        ? payload.map(normalizeOrganSystem)
        : [];
    },
  },
  actions: {
    queryPesticides({ dispatch, commit }) {
      dispatch("setPreloader", true);
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "pesticides")
        .then((res) => {
          commit("setPesticides", res.data);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    storePesticide({ dispatch, commit }, formData) {
      dispatch("setPreloader", true);
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "pesticides", formData)
        .then((res) => {
          dispatch("queryPesticides");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("closeModal", true);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    updatePesticide({ dispatch, commit }, payload) {
      dispatch("setPreloader", true);
      axios
        .patch(
          process.env.VUE_APP_API_ENDPOINT + "pesticides/" + payload[0],
          payload[1],
        )
        .then((res) => {
          dispatch("queryPesticides");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("closeModal", true);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    destroyPesticide({ dispatch, commit }, country_id) {
      dispatch("setPreloader", true);
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "pesticides/" + country_id)
        .then((res) => {
          dispatch("queryPesticides");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },

    queryActiveIngredients({ dispatch, commit }) {
      dispatch("setPreloader", true);
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "substances")
        .then((res) => {
          commit("setActiveIngredients", res.data);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    storeActiveIngredient({ dispatch, commit }, formData) {
      dispatch("setPreloader", true);
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "substances", formData)
        .then((res) => {
          dispatch("queryActiveIngredients");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("closeModal", true);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    updateActiveIngredient({ dispatch, commit }, payload) {
      dispatch("setPreloader", true);
      axios
        .patch(
          process.env.VUE_APP_API_ENDPOINT + "substances/" + payload[0],
          payload[1],
        )
        .then((res) => {
          dispatch("queryActiveIngredients");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("closeModal", true);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    destroyActiveIngredient({ dispatch, commit }, country_id) {
      dispatch("setPreloader", true);
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "substances/" + country_id)
        .then((res) => {
          dispatch("queryActiveIngredients");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },

    queryCrops({ dispatch, commit }) {
      dispatch("setPreloader", true);
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "scopes")
        .then((res) => {
          commit("setCrops", res.data);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    storeCrop({ dispatch, commit }, formData) {
      dispatch("setPreloader", true);
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "scopes", formData)
        .then((res) => {
          dispatch("queryCrops");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("closeModal", true);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    updateCrop({ dispatch, commit }, payload) {
      dispatch("setPreloader", true);
      axios
        .patch(
          process.env.VUE_APP_API_ENDPOINT + "scopes/" + payload[0],
          payload[1],
        )
        .then((res) => {
          dispatch("queryCrops");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("closeModal", true);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    destroyCrop({ dispatch, commit }, country_id) {
      dispatch("setPreloader", true);
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "scopes/" + country_id)
        .then((res) => {
          dispatch("queryCrops");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },

    queryPests({ dispatch, commit }) {
      dispatch("setPreloader", true);
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "pests")
        .then((res) => {
          commit("setPests", res.data);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    storePest({ dispatch, commit }, formData) {
      dispatch("setPreloader", true);
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "pests", formData)
        .then((res) => {
          dispatch("queryPests");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("closeModal", true);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    updatePest({ dispatch, commit }, payload) {
      dispatch("setPreloader", true);
      axios
        .patch(
          process.env.VUE_APP_API_ENDPOINT + "pests/" + payload[0],
          payload[1],
        )
        .then((res) => {
          dispatch("queryPests");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("closeModal", true);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    destroyPest({ dispatch, commit }, country_id) {
      dispatch("setPreloader", true);
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "pests/" + country_id)
        .then((res) => {
          dispatch("queryPests");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },

    queryOrganSystems({ dispatch, commit }) {
      dispatch("setPreloader", true);
      axios
        .get(process.env.VUE_APP_API_ENDPOINT + "organsystems")
        .then((res) => {
          commit("setOrganSystems", res.data);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    storeOrganSystem({ dispatch, commit }, formData) {
      dispatch("setPreloader", true);
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "organsystems", formData)
        .then((res) => {
          dispatch("queryOrganSystems");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("closeModal", true);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    updateOrganSystem({ dispatch, commit }, payload) {
      dispatch("setPreloader", true);
      axios
        .patch(
          process.env.VUE_APP_API_ENDPOINT + "organsystems/" + payload[0],
          payload[1],
        )
        .then((res) => {
          dispatch("queryOrganSystems");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("closeModal", true);
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
    destroyOrganSystem({ dispatch, commit }, country_id) {
      dispatch("setPreloader", true);
      axios
        .delete(process.env.VUE_APP_API_ENDPOINT + "organsystems/" + country_id)
        .then((res) => {
          dispatch("queryOrganSystems");
          dispatch("setToast", {
            status: "success",
            message: res.data.message,
          });
          dispatch("setPreloader", false);
        })
        .catch((error) => {
          dispatch("setToastHttpError", error.response, { root: true });
        });
    },
  },
  getters: {
    getPesticides: (state) => {
      return state.pesticides;
    },
    getActiveIngredients: (state) => {
      return state.active_ingredients;
    },
    getCrops: (state) => {
      return state.crops;
    },
    getPests: (state) => {
      return state.pests;
    },
    getOrganSystems: (state) => {
      return state.organSystems;
    },

    getPesticidesOptions(state) {
      return function(all) {
        let pesticides = [];
        if (state.pesticides)
          for (let item of state.pesticides)
            pesticides.push({ id: item.id, text: item.name });
        if (all) {
          let text_items = {};
          _.each(langs.state.list, (p) => {
            // for all langs
            text_items[p.value] = "All";
          });
          pesticides.unshift({ id: 0, text: [text_items] });
        }
        return pesticides;
      };
    },
    getCropsOptions(state) {
      return function(all) {
        let crops = [];
        if (state.crops)
          for (let item of state.crops)
            crops.push({ id: item.id, text: item.name });
        if (all) crops.unshift({ id: 0, text: "All" });
        return crops;
      };
    },
  },
};
